import { DisplayAt } from '@/types';

export const DisplayAtOptions = [
	{ content: 'Home page', value: DisplayAt.HOME },
	{ content: 'All pages', value: DisplayAt.ALL },
	{ content: 'Specific pages', value: DisplayAt.SPECIFIC },
	{ content: 'Category pages', value: DisplayAt.CATEGORY },
	{ content: 'Product pages', value: DisplayAt.PRODUCT },
];

export const PRODUCT_CONTAINER_DISPLAY_AT_VALUES: DisplayAt[] = [DisplayAt.PRODUCT, DisplayAt.CATEGORY];
